import { render, staticRenderFns } from "./WarningIcon.vue?vue&type=template&id=5d37d1e5&scoped=true&"
import script from "./WarningIcon.vue?vue&type=script&lang=js&"
export * from "./WarningIcon.vue?vue&type=script&lang=js&"
import style0 from "./WarningIcon.vue?vue&type=style&index=0&id=5d37d1e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d37d1e5",
  null
  
)

export default component.exports